import { featureItems } from '@/pages/home/mocks/data';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full mb-3">
            核心优势
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">为什么选择51吃瓜</h2>
          <p className="text-foreground-500 mt-2 text-sm">百万瓜友的共同选择，吃瓜体验全面升级</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {featureItems.map((item) => (
            <div key={item.id} className="group p-6 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 hover:bg-background-50 transition-all text-center">
              <div className="w-14 h-14 mx-auto rounded-full bg-primary-50 flex items-center justify-center mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}